import PLPState from "../plp/plp_state.js";
import productType from "../plp/ui/productType_filter.js";
import Button from '../form/button';

$(function () {
    $(".product-filters-card").each(function() {
        let plpState = PLPState.getInstance();
        let loading = false;

        let card = $(this);
        let plpBase = $('.product-filters-card').data('plp-url-base');
        let shopBtn = new Button(card.find(".new-btn"));
        
        // Load Filters
        loadPLPFilters();

        $(document).on(
            "change",
            '.multi-select.select .list .list-item input[type="checkbox"]',
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                let filterName = $(this).data("filtertype");
                let value = $(this).attr("id");
                if (this.checked) {
                    plpState.add(filterName, value);
                    getPLPUrl();
                } else {
                    plpState.remove(filterName, value);
                }
            }
        );

        $(document).on(
            "click",
            ".filter-container .multi-select .select-button",
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                getPLPUrl();
            }
        );

        function getPLPUrl() {

            shopBtn.showSpinner();

            axios({
                method: "POST",
                url: `/${plpBase}/load-product-listing-page-url-ajax`,
                data: { filters: plpState.state }
            }).then(function (response) {
                shopBtn.hideSpinner();
                shopBtn.button.attr("href", response.data.url);
            });
        }

        function loadPLPFilters() {
            $(".filters").empty();
            $(".loading").removeClass("d-none");
            loading = true;

            axios({
                method: "POST",
                url: `/${plpBase}/load-product-filters-ajax`,
                data: { filters: plpState.state },
            }).then(function (response) {
                $(".filters").append(response.data.html);
                $(".loading").addClass("d-none");
    
                loading = false;
                card.find(".new-btn").show();
            });
        }

        $(document).on("change", 'select[name="category"]', {route: plpBase, loadPLP: getPLPUrl}, function(event) {
            $("body").css("cursor", "wait");
            productType(event);
        });
    });
});
